var React = require('react');

function Dollar (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"$"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","fontFamily":"Avenir-Medium, Avenir","fontSize":"16","fontWeight":"400","letterSpacing":"-0.200000003","key":3},React.createElement("g",{"id":"Worksheet-View---Add-Lot","transform":"translate(-323.000000, -799.000000)","fill":"#BEBEBE"},React.createElement("g",{"id":"Group-39","transform":"translate(285.000000, 185.000000)"},React.createElement("text",{"id":"$"},React.createElement("tspan",{"x":"38","y":"628"},"$")))))]);
}

Dollar.defaultProps = {"width":"9px","height":"16px","viewBox":"0 0 9 16","version":"1.1"};

module.exports = Dollar;

Dollar.default = Dollar;
